import _ from 'lodash';
import moment from 'moment';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page, NumericalInput, Switch } from '../shared';
import { CustomGoalModal, ConfirmModal } from '../modals';

import { Link, Redirect } from 'react-router-dom';

import {
  fetchCurrentSprintForEmployee,
  updateCurrentSprintGoalsForEmployee
} from '../../actions/sprint';

import {
  fetchSalesCompetencyReviewItems,
  fetchSalesCompetencyReviewsForSeller,
} from '../../actions/salesCompetencyReviews';

import {
  getFourboxCategories,
  sprintGoalsAreDirty,
  isNumerical,
  focusAfterTimeout,
  sellingCompetencies,
  getPredictiveSkillsReviewScoresFromReviewData,
} from '../../util';
import {
  getCurrentQuarterString
} from '../../util/quarters';

import {
  ActiveCriticalExpertiseItemsSelector,
  ScoredCriticalExpertiseItemsSelector,
} from '../../selectors';

class SprintSetupPage extends Component {

  state = {
    employeeId: null,
    cachedSprint: null,
    updatedSprint: null,
    showingCustomGoalWarningModal: false,
    showingCustomGoalModal: false,
    customGoalCategory: false,
    removingCustomGoal: false,
    renamingGoal: null,
    renamingGoalNewName: '',
    redirectTo: false,
    editingMeasureGoal: {}
  }

  sprintIsNew(){
    return !this.state.cachedSprint || !this.state.cachedSprint._id;
  }
  sprintIsOutdated(){
    return (this.state.cachedSprint || {}).period !== getCurrentQuarterString();
  }

  revertChanges(){
    this.setState({
      updatedSprint: this.state.cachedSprint
    });
  }

  setupIsDirty(){
    const { cachedSprint, updatedSprint } = this.state;

    if(!updatedSprint){
      return false;
    }
    if(this.sprintIsNew()){
      if(updatedSprint.goals && updatedSprint.goals.length > 0){
        return true;
      }
      else{
        return false;
      }
    }

    return sprintGoalsAreDirty(cachedSprint.goals, updatedSprint.goals);
  }

  saveSprintChanges(){
    //don't use save method, update method includes resetting from "paused" state if current sprint is paused
    this.props.updateCurrentSprintGoalsForEmployee(this.state.employeeId, this.state.updatedSprint, () => {
      this.setState({
        redirectTo: `/people/${this.state.employeeId}/sprint`,
      });
    });
  }

  cleanSprintForCompetenciesEnabled(sprint){
    let cleanedSprintGoals = _.filter(sprint.goals, goal => {
      return goal.category !== 'behavior' && goal.category !== 'skill';
    });

    return {
      ...sprint,
      goals: cleanedSprintGoals
    }
  }

  componentDidUpdate(prevProps, prevState){
    //have to deal w/ this two ways:
    // 1) don't have prior sprint data, in which case setup
    // 2) already mapped sprint data, but didn't map w/ cleaned goals, and know we know that we have competencies enabeld
    if(!prevState.cachedSprint && this.props.sprint && !this.props.saving){

      const sprintToAssign = this.props.competenciesEnabled ? this.cleanSprintForCompetenciesEnabled(this.props.sprint) : this.props.sprint;

      this.setState({
        cachedSprint: sprintToAssign,
        updatedSprint: sprintToAssign,
      });
    }
    else if(!prevProps.competenciesEnabled && this.props.competenciesEnabled && this.state.cachedSprint){
      this.setState({
        cachedSprint: this.cleanSprintForCompetenciesEnabled(this.state.cachedSprint),
        updatedSprint: this.cleanSprintForCompetenciesEnabled(this.state.updatedSprint),
      })
    }
  }

  scoresForLatestSalesCompetencyReview(){
    if(!this.props.salesCompetencyReviewItems || !this.props.scoredCriticalExpertiseItems || !this.state.latestSalesCompetencyReviewForSeller){
      return null;
    }

    return getPredictiveSkillsReviewScoresFromReviewData(this.props.salesCompetencyReviewItems, this.props.scoredCriticalExpertiseItems, this.state.latestSalesCompetencyReviewForSeller);
  }
  getLatestSalesCompetencyScoreForItem(itemType, itemId){
    const scores = this.scoresForLatestSalesCompetencyReview();

    if(!scores){
      return null;
    }

    console.log('scores: ', scores);

    if(itemType === 'competency'){
      console.log('scores for C id: ', itemId);
      console.log('score value: ', (_.find(scores.scoresByCompetency, { id: itemId }) || {}).score);
      return (_.find(scores.scoresByCompetency, { id: itemId }) || {}).score;
    }
    else if(itemType === 'expertise'){
      console.log('scores for E id: ', itemId);
      console.log('score value: ', (_.find(scores.scoresByCriticalExpertise, { id: itemId}) || {}).score);
      return (_.find(scores.scoresByCriticalExpertise, { id: itemId}) || {}).score;
    }
    else{
      return null;
    }
  }

  componentWillMount(){
    const employeeId = this.props.match.params.employeeId;

    this.setState({
      employeeId,
    });

    this.props.fetchCurrentSprintForEmployee(employeeId);

    this.props.fetchSalesCompetencyReviewItems();
    this.props.fetchSalesCompetencyReviewsForSeller(employeeId, reviews => {
      this.setState({
        latestSalesCompetencyReviewForSeller: _.head(_.orderBy(_.filter(reviews, { status: 'complete' }), 'startedOn', 'desc'))
      });
    });
  }

  currentGoals(){
    if(!this.state.updatedSprint){
      return [];
    }

    let currentGoals = [];

    currentGoals = this.state.updatedSprint.goals;

    return currentGoals;
  }

  goalIsSelected(id){

    const foundItem = _.find(this.currentGoals(), function(item){
      return item.id == id;
    });

    return foundItem ? true : false;
  }

  measureGoalIsEditing(id){
    const foundItem = _.find(this.currentGoals(), function(item){
      return item.id == id;
    });

    //console.log('foundItem: ', foundItem);

    return (foundItem && foundItem.goalTarget) || this.state.editingMeasureGoal === id ? true : false;
  }

  valueForGoal(id){

    const foundItem = _.find(this.currentGoals(), function(item){
      return item.id == id;
    });

    return foundItem ? foundItem.goalTarget : '';
  }
  monthlyValueForGoal(id, monthIndex){

    console.log('current goals: ', this.currentGoals());

    const foundItem = _.find(this.currentGoals(), function(item){
      return item.id == id;
    });

    return foundItem ? (foundItem.goalTargets ? (foundItem.goalTargets[monthIndex] || '') : '') : '';
  }

  showRemovingCustomGoalConfirmModal(goal){
    this.setState({
      removingCustomGoal: goal,
    });
  }
  renderRemoveCustomGoalModal(){
    return (
      <ConfirmModal
        iconKey='warning'
        confirmText='Remove custom goal'
        cancelText='Nevermind'
        message={`After being removed, the ${(this.state.removingCustomGoal ? this.state.removingCustomGoal.name : '').toUpperCase()} custom goal will be deleted and removed from all reporting for this user`}
        onConfirm={() => { this.removeGoalFromSprint(this.state.removingCustomGoal, true); this.setState({ removingCustomGoal: false }); } }
        hide={() => { this.setState({ removingCustomGoal: false }); } }
        visible={this.state.removingCustomGoal}
      />
    );
  }

  addGoalToSprint(goal){
    this.setState({
      updatedSprint: {
        ...this.state.updatedSprint,
        goals: _.union(this.state.updatedSprint.goals, [goal])
      }
    });
  }
  removeGoalFromSprint(goal, removeCustomGoalOverwrite){

    //don't remove immediately - make sure user wants to remove and understands consequences
    if(goal.isCustomGoal && !removeCustomGoalOverwrite){
      this.showRemovingCustomGoalConfirmModal(goal);
      return;
    }

    this.setState({
      updatedSprint: {
        ...this.state.updatedSprint,
        goals: _.filter(this.state.updatedSprint.goals, item => {
          return item.id !== goal.id;
        })
      }
    });
  }
  updateGoalInSprint(goal){

    // console.log('updateGoalInSprint: ', goal);

    //copy goals since we will be manipulating array
    let goals = [ ...this.state.updatedSprint.goals];

    let matchingGoalIndex = _.findIndex(goals, item => {
      return item.id === goal.id;
    });

    if(matchingGoalIndex !== -1){
      //https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
      goals.splice(matchingGoalIndex, 1, {
        ...goals[matchingGoalIndex],
        ...goal,
      });
    }
    else{
      goals.push(goal);
    }

    this.setState({
      updatedSprint: {
        ...this.state.updatedSprint,
        goals
      }
    });
  }

  toggleGoal(goal){
    if(this.goalIsSelected(goal.id)){
      this.removeGoalFromSprint(goal);
    }
    else{
      this.addGoalToSprint(goal);
    }
  }

  updateGoalTarget(goal, target){

    const updatedGoal = {
      ...goal,
      goalTarget: target
    }

    //item already in goal array
    if(this.goalIsSelected(updatedGoal.id)){
      //set value
      if(target !== ''){
        this.updateGoalInSprint(updatedGoal);
      }
      else{
        this.removeGoalFromSprint(updatedGoal);
      }
    }
    else{
      if(target !== ''){
        this.addGoalToSprint(updatedGoal);
      }
      else{
        //do nothing, goal not in sprint, and not set to anything
      }
    }
  }

  updateGoalMonthlyTargets(goal, targetIndex, newTargetValue){

    console.log('updateGoalMonthlyTargets with goal data: ', goal);

    const existingGoalTargets = {
      first: this.monthlyValueForGoal(goal.id, 'first'),
      second: this.monthlyValueForGoal(goal.id, 'second'),
      third: this.monthlyValueForGoal(goal.id, 'third'),
    }

    console.log('existingGoalTargets:', existingGoalTargets);

    const updatedGoal = {
      ...goal,
      goalTargets: {
        ...existingGoalTargets,
        [targetIndex]: newTargetValue || ''
      }
    }

    //item already in goal array
    if(this.goalIsSelected(updatedGoal.id)){
      //set value
      if(newTargetValue !== ''){
        this.updateGoalInSprint(updatedGoal);
      }
      else{
        if(targetIndex === 'first' && existingGoalTargets['first'] === '' && existingGoalTargets['third'] === ''){
          this.removeGoalFromSprint(updatedGoal);
        }
        else if(targetIndex === 'second' && existingGoalTargets['first'] === '' && existingGoalTargets['third'] === ''){
          this.removeGoalFromSprint(updatedGoal);
        }
        else if(targetIndex === 'third' && existingGoalTargets['first'] === '' && existingGoalTargets['second'] === ''){
          this.removeGoalFromSprint(updatedGoal);
        }
        else{
          this.updateGoalInSprint(updatedGoal);
        }
      }
    }
    else{
      if(newTargetValue !== ''){
        this.addGoalToSprint(updatedGoal);
      }
      else{
        //do nothing, goal not in sprint, and not set to anything
      }
    }
  }

  updateGoalMeta(goal, newMeta){
    const updatedGoal = {
      ...goal,
      goalMeta: {
        ...goal.goalMeta,
        ...newMeta
      }
    }

    console.log('saving updatedGoal: ', updatedGoal);

    this.updateGoalInSprint(updatedGoal);
  }

  beginRenamingGoal(renamingGoal){
    this.setState({
      renamingGoal,
    });

    focusAfterTimeout(this, 'renamingThisGoalInput');
  }
  confirmRenameGoal(){

    const renamingGoal = this.state.renamingGoal;
    const customDescription = (this.state.renamingGoalNewName && this.state.renamingGoalNewName !== '') ? this.state.renamingGoalNewName : false;

    this.updateGoalMeta(renamingGoal, {
      customDescription
    });

    this.setState({
      renamingGoal: null,
      renamingGoalNewName: ''
    });
  }
  cancelRenameGoal(){
    this.setState({
      renamingGoal: null,
      renamingGoalNewName: '',
    });
  }

  renderGoalCustomEditActions(goal){

    const { renamingGoal, renamingGoalNewName } = this.state;

    const renamingThisGoal = renamingGoal && renamingGoal.id === goal.id;

    if(goal.goalType === 'forecast'){
      if(renamingThisGoal){
        return (
          <div className="item-custom-actions">
            <input value={renamingGoalNewName} onChange={e => { this.setState({ renamingGoalNewName: e.target.value }) }} ref={input => { this.renamingThisGoalInput = input; }} className="custom-input" type="text" placeholder={goal.description} />
            <div onClick={this.cancelRenameGoal.bind(this)} className="custom-action cancel">Cancel</div>
            <div onClick={this.confirmRenameGoal.bind(this)} className="custom-action confirm">Save</div>
          </div>
        );
      }
      else{
        return(
          <div className="item-custom-actions">
            <div onClick={() => { this.beginRenamingGoal(goal); } } className="custom-action cancel">Rename</div>
          </div>
        );
      }
    }
    else{
      return null;
    }
  }

  descriptionForGoal(goal){
    const foundItem = _.find(this.currentGoals(), function(currentGoal){
      return currentGoal.id == goal.id;
    });

    if(!foundItem){
      return goal.description;
    }
    else{
      if(foundItem.goalMeta && foundItem.goalMeta.customDescription){
        return foundItem.goalMeta.customDescription;
      }
      else{
        return goal.description;
      }
    }
  }

  renderGoalDescription(goal){

    const { renamingGoal } = this.state;
    const renamingThisGoal = renamingGoal && renamingGoal.id === goal.id;

    if(renamingThisGoal){
      return null;
    }
    else{
      return (
        <div className="item-description fs-block">{this.descriptionForGoal(goal)}</div>
      );
    }
  }

  renderGoalValue(item){

    //console.log('renderGoalValue: ', item);

    const goalIsSelected = this.goalIsSelected(item.id);

    if(item.goalType === 'do'){
      return (
        <div className="item-switch">
          <Switch
            id="some-switch"
            checked={goalIsSelected}
            onChange={checked => { this.toggleGoal(item); } }
          />
        </div>
      )
    }
    else if(item.goalType === 'measure'){

      return (
        <div className="item-value">
          {this.measureGoalIsEditing(item.id) &&
            <NumericalInput
              key={`input-for-measure-goal-${item.id}`}
              inputRef={input => { this[`inputForGoal_${item.id}`] = input; }}
              className='selected fs-block'
              formatThousands={true}
              value={this.valueForGoal(item.id)}
              onUpdate={val => { this.updateGoalTarget(item, val); } }
              onBlur={() => { this.setState({editingMeasureGoal: null }); } }
            />
          }
          {!this.measureGoalIsEditing(item.id) &&
            <Switch
              id="some-switch"
              checked={this.state.editingMeasureGoal === item.id}
              onChange={checked => { this.setState({ editingMeasureGoal: item.id }); focusAfterTimeout(this, `inputForGoal_${item.id}`); } }
            />
        }
        </div>
      )
    }
    else if(item.goalType === 'forecast'){
      // console.log('rendering forecast value: ', this.valueForGoal(item.id));

      const goalHasNonDefaultFrequency = item.frequency && item.frequency !== '';

      return (
        <div className={`item-value ${goalHasNonDefaultFrequency ? 'has-multiple' : ''}`}>
          {!goalHasNonDefaultFrequency &&
            <NumericalInput className={'extra-wide fs-block ' + (goalIsSelected ? 'selected' : '')} formatThousands={true} value={this.valueForGoal(item.id)} onUpdate={val => { this.updateGoalTarget(item, val); } } />
          }
          {goalHasNonDefaultFrequency &&
            <React.Fragment>
              <NumericalInput placeholder='First Month' className={'multiple extra-wide fs-block ' + (goalIsSelected ? 'selected' : '')} formatThousands={true} value={this.monthlyValueForGoal(item.id, 'first')} onUpdate={val => { this.updateGoalMonthlyTargets(item, 'first', val); } } />
              <NumericalInput placeholder='Second Month' className={'multiple extra-wide fs-block ' + (goalIsSelected ? 'selected' : '')} formatThousands={true} value={this.monthlyValueForGoal(item.id, 'second')} onUpdate={val => { this.updateGoalMonthlyTargets(item, 'second', val); } } />
              <NumericalInput placeholder='Third Month' className={'multiple extra-wide fs-block ' + (goalIsSelected ? 'selected' : '')} formatThousands={true} value={this.monthlyValueForGoal(item.id, 'third')} onUpdate={val => { this.updateGoalMonthlyTargets(item, 'third', val); } } />
            </React.Fragment>
          }
        </div>
      )
    }
  }

  renderSprintGoal(goal){

    //console.log('rendering sprint goal: ', goal);

    const goalIsSelected = this.goalIsSelected(goal.id);

    //don't show inactive goals that aren't currently selected
    if(goal.inactive && !goalIsSelected){
      return null;
    }

    const goalHasTwoInputs = false;
    const goalIsMonthly = goal.frequency === 'monthly'
    const goalHasThreeInputs = goal.goalType === 'forecast' && goalIsMonthly;

    const goalHasDescription = goal.description && goal.description !== '';

    return (
      <li key={goal.id} className={'item' + (goalIsSelected ? ' selected' : '') + (goal.inactive ? ' inactive' : '') + (goalHasTwoInputs ? ' has-two-inputs' : '') + (goalHasThreeInputs ? ' has-three-inputs' : '') + (!goalHasDescription ? ' no-description' : '')}>
        {goal.isCustomGoal &&
          <div className="item-custom-flag">Custom Goal</div>
        }
        {goalIsSelected && goal.inactive &&
          <div className="item-inactive-flag">INACTIVE (WILL BE AUTOMATICALLY REMOVED NEXT WEEK)</div>
        }
        <div className="item-name">{goal.name}{goalIsMonthly ? ' (Monthly)' : ''}{goal.latestScore ? ` (${goal.latestScore})` : ''}</div>
        {this.renderGoalDescription(goal)}
        {this.renderGoalValue(goal)}
        {this.renderGoalCustomEditActions(goal)}
      </li>
    );
  }

  optionsForCategory(options, categoryKey){
    return _.filter(options, option => {
      return option.category === categoryKey;
    });
  }

  renderCreateCustomGoalForCategory(categoryKey){

    //can't do custom goals for these categories
    if(categoryKey === 'competency' || categoryKey === 'expertise'){
      return null;
    }

    return(
      <li onClick={() => { this.showingCustomGoalWarningModal(categoryKey); }} className="item new">
        <div className="item-name">Custom</div>
        <div className="item-description fs-block">Create custom {categoryKey} goal</div>
      </li>
    );
  }

  showingCustomGoalWarningModal(categoryKey){
    this.setState({
      showingCustomGoalWarningModal: true,
      customGoalCategory: categoryKey,
    });
  }
  showCustomGoalModal(){
    this.setState({
      showingCustomGoalWarningModal: false,
      showingCustomGoalModal: true,
    });
  }
  hideCustomGoalModal(){
    this.setState({
      showingCustomGoalModal: false,
      customGoalCategory: false,
    });
  }
  addCustomGoal(goal){
    this.addGoalToSprint(goal);
    this.hideCustomGoalModal();
  }
  renderCustomGoalModal(){
    return <CustomGoalModal
      userData={this.props.viewingUser.data}
      category={this.state.customGoalCategory}
      onCreate={this.addCustomGoal.bind(this)}
      hide={this.hideCustomGoalModal.bind(this)}
      visible={this.state.showingCustomGoalModal}
      />
  }
  renderCustomGoalWarningModal(){
    return <ConfirmModal
      iconKey='warning'
      confirmText='Continue'
      message='Custom goals are not visible in team or organization reports and should be used sparingly.'
      onConfirm={this.showCustomGoalModal.bind(this)}
      hide={() => { this.setState({ showingCustomGoalWarningModal: false }) }}
      visible={this.state.showingCustomGoalWarningModal}
      />
  }

  renderSprintSetup(){

    const { updatedSprint } = this.state;

    const currentUserGoals = (updatedSprint ? (updatedSprint.goals ? updatedSprint.goals : []) : []);

    console.log('currentUserGoals: ', currentUserGoals);

    const goalOptions = [
      ...(this.props.goalOptions || []),
      ..._.map(this.props.activeCriticalExpertiseItems, item => {
        return {
          category: 'expertise',
          description: null,
          goalType: 'do',
          id: item.id,
          name: item.name,
          ...(this.getLatestSalesCompetencyScoreForItem('expertise', item.id) && { latestScore: this.getLatestSalesCompetencyScoreForItem('expertise', item.id) })
        }
      }),
      ..._.map(sellingCompetencies(), competency => {
        return {
          category: 'competency',
          description: null,
          goalType: 'do',
          id: competency.id,
          name: competency.name,
          ...(this.getLatestSalesCompetencyScoreForItem('competency', competency.id) && { latestScore: this.getLatestSalesCompetencyScoreForItem('competency', competency.id) })
        }
      }),
    ]
    const customOptions = _.filter(currentUserGoals, goal => {
      return goal.isCustomGoal;
    });

    const goalOptionsAndCustomOptions = _.union(goalOptions, customOptions);

    if(!goalOptions){
      return null;
    }

    return (
      <div className="fourbox-options">
        {_.map(getFourboxCategories(this.props.competenciesEnabled, true), category => {
          return (
            <div key={category.key} className="fourbox-category">
              <h6>{category.name}</h6>
              <ul className="category-options">
                {_.map(this.optionsForCategory(goalOptionsAndCustomOptions, category.key), this.renderSprintGoal.bind(this) )}
                {this.props.customGoalsEnabled && this.renderCreateCustomGoalForCategory(category.key)}
              </ul>
            </div>
          )
        })}
      </div>
    );
  }

  renderUpdateButton(){
    const { saving } = this.props;

    if(saving){
      return <button className="button primary disabled" disabled>Saving...</button>
    }
    else{
      if(this.setupIsDirty() || this.sprintIsOutdated()){
        return <button onClick={this.saveSprintChanges.bind(this)} className="button primary">{this.sprintIsNew() ? 'Save' : 'Update'}</button>
      }
      else{
        return <Link to={`/people/${this.state.employeeId}/sprint`}><button className="button primary">Done</button></Link>
      }
    }
  }
  renderCancelButton(){
    if(this.setupIsDirty()){
      return <button onClick={this.revertChanges.bind(this)} className="button grey-outline">Revert</button>
    }
    else{
      return null;
    }
  }

  currentSprintIsPausedForSetup(){
    return (this.props.sprint || {}).status === 'paused';
  }

  renderEditingMidQuarterWarning(){

    if(this.sprintIsNew() || this.sprintIsOutdated() || this.currentSprintIsPausedForSetup()){
      return null;
    }
    else{
      return <div className="page-warning">Editing sprint goals mid quarter is strongly discouraged as it will negatively affect team and organization reporting</div>
    }
  }

  renderIntro(){
    if(this.props.competenciesEnabled){
      return (
        <React.Fragment>
          <p>Select the selling competencies, knowledge items, activities, and outcomes {this.viewingUserName()} should work on for this quarter. Here are some best practices for setting up weekly sprint goals:</p>
          <ul className="setup-tips">
            <li>Select a maximum of 1-2 <b>Selling Competencies</b> and <b>Critical Expertise</b> items for the first quarter, and 2-3 competencies/expertise items thereafter</li>
            <li>Select a balance of <b>Selling Competencies</b> and <b>Critical Expertise</b> that will 1) immediately improve sales and 2) encourage long term development</li>
            <li>Align competency and expertise selections to quarterly development goals for {this.viewingUserName()} and your organization</li>
            <li>Keep in mind activies are tracked "per week". If you would like a target to be achieved less frequently, still enter (1) for the weekly goal.</li>
            <li>Outcomes are measured quarterly, {this.viewingUserName()} will simply be updating his estimate for the quarter in each report</li>
          </ul>
        </React.Fragment>
      )
    }
    else{
      return (
        <React.Fragment>
          <p>Select the behaviors, activities, skills, and outcomes {this.viewingUserName()} should work on for this quarter. Here are some best practices for setting up weekly sprint goals:</p>
          <ul className="setup-tips">
            <li>Select a maximum of 1-2 behaviors and skills for the first quarter, and 2-3 behaviors/skills thereafter</li>
            <li>Select a balance of behaviors and skills that will 1) immediately improve sales and 2) encourage long term development</li>
            <li>Align behavior and skill selections to quarterly development goals for {this.viewingUserName()} and your organization</li>
            <li>Keep in mind activies are tracked "per week". If you would like a target to be achieved less frequently, still enter (1) for the weekly goal.</li>
            <li>Outcomes are measured quarterly, {this.viewingUserName()} will simply be updating his estimate for the quarter in each report</li>
          </ul>
        </React.Fragment>
      )
    }
  }

  viewingUserName(){
    return ((this.props.viewingUser || {}).data || {}).firstName;
  }

  render(){

    if(this.state.redirectTo){
      return <Redirect to={this.state.redirectTo} />;
    }

    const loading = !this.props.goalOptions;

    return (
      <Page pageClass="sprint-setup" loading={loading}>
        <div className="page-title">
          <h1>Sprint Goals Setup</h1>
        </div>
        <div className="page-actions">
          {this.renderUpdateButton()}
          {this.renderCancelButton()}
        </div>
        <div className="page-section">
          {this.renderIntro()}
          {this.renderEditingMidQuarterWarning()}
          {this.renderSprintSetup()}
        </div>
        {this.renderCustomGoalWarningModal()}
        {this.renderCustomGoalModal()}
        {this.renderRemoveCustomGoalModal()}

        <div className="page-actions">
          {this.renderUpdateButton()}
          {this.renderCancelButton()}
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    viewingUser: state.viewingUser,
    saving: state.sprint.saving,
    sprint: state.sprint.data ? state.sprint.data : null,
    goalOptions: state.organization.data ? state.organization.data.sprintGoals : null,
    customGoalsEnabled: state.organization.data ? state.organization.data.customGoalsEnabled : null,
    competenciesEnabled: state.organization.data ? state.organization.data.competenciesEnabled : false,
    activeCriticalExpertiseItems: ActiveCriticalExpertiseItemsSelector(state),
    scoredCriticalExpertiseItems: ScoredCriticalExpertiseItemsSelector(state),
    salesCompetencyReviewItems: state.salesCompetencyReviewItems.items,
  }
}

export default connect(mapStateToProps, { fetchCurrentSprintForEmployee, updateCurrentSprintGoalsForEmployee, fetchSalesCompetencyReviewItems, fetchSalesCompetencyReviewsForSeller })(SprintSetupPage);



// WEBPACK FOOTER //
// ./src/components/sprint/setup.js